export enum AutonomyCodes {
    CASTILLA_LA_MANCHA = 'ES-CM',
    ARAGON = 'ES-AR',
    MADRID = 'ES-MD',
    CASTILLA_LEON = 'ES-CL',
    CATALUÑA = 'ES-CT'
}